export default "__VITE_ASSET__C_9tIT9r__"